/* Truro mobile sticky purchase bar: observe, mirror and delegate to canonical product form and Measura only. */
(() => {
  const selector = '[data-tf-sticky-purchase]';
  const isMobile = window.matchMedia('(max-width: 749px)');

  function initialise(bar) {
    if (!bar || bar.dataset.initialised === 'true') return;
    const form = document.getElementById(bar.dataset.formId);
    const productInfo = document.getElementById(bar.dataset.productInfoId);
    const nativeSubmit = form && form.querySelector('[type="submit"]');
    const summary = bar.querySelector('[data-tf-sticky-summary]');
    const measure = bar.querySelector('[data-tf-sticky-measure]');
    const measureMinus = bar.querySelector('[data-tf-sticky-measure-minus]');
    const measurePlus = bar.querySelector('[data-tf-sticky-measure-plus]');
    const length = bar.querySelector('[data-tf-sticky-length]');
    const submit = bar.querySelector('[data-tf-sticky-submit]');
    const submitLabel = bar.querySelector('[data-tf-sticky-submit-label]');
    const price = bar.querySelector('[data-tf-sticky-price]');
    const status = bar.querySelector('[data-tf-sticky-status]');
    if (!form || !productInfo || !nativeSubmit || !summary || !submit || !submitLabel) return;
    bar.dataset.initialised = 'true';
    document.body.classList.add('tf-mobile-sticky-purchase-enabled');

    function cleanText(value) { return (value || '').replace(/\s+/g, ' ').trim(); }
    function formLabel() { return cleanText(nativeSubmit.querySelector('span')?.textContent || nativeSubmit.textContent) || 'Add to basket'; }
    function measuraPrice() {
      const text = cleanText(productInfo.querySelector('.measura-total-price')?.textContent);
      return text ? text.replace(/^Total price:\s*/i, '') : '';
    }
    function measuraLength() {
      const text = cleanText(productInfo.querySelector('.measura-total-measurement-text')?.textContent);
      return text ? text.replace(/^Total length:\s*/i, '') : '';
    }
    function nativeMeasurement() {
      const root = productInfo.querySelector('.measura-block-entry');
      return {
        root,
        input: root?.querySelector('.measura-number-group input'),
        minus: root?.querySelector('.measura-minus'),
        plus: root?.querySelector('.measura-plus'),
      };
    }
    function isDisabled(control) { return !control || control.disabled || control.getAttribute('aria-disabled') === 'true'; }
    function focusCanonicalControl() {
      const measurement = nativeMeasurement();
      const target = measurement.input || productInfo.querySelector('variant-selects select, variant-radios input, .product-form__input input:not([type="hidden"]), .product-form__input select') || nativeSubmit;
      productInfo.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => target.focus({ preventScroll: true }), 350);
    }
    function isOverlayOpen() {
      return Boolean(document.querySelector('dialog[open], .modal-dialog[open], cart-drawer.active, .drawer.active, .menu-drawer-container.menu-opening'));
    }
    function setVisibility(show) {
      const shouldShow = Boolean(show && isMobile.matches && !isOverlayOpen() && document.activeElement && !productInfo.contains(document.activeElement));
      bar.hidden = !shouldShow;
      document.body.classList.toggle('tf-mobile-sticky-purchase-visible', shouldShow);
    }
    function update() {
      const disabled = isDisabled(nativeSubmit);
      const label = formLabel();
      const livePrice = measuraPrice() || bar.dataset.defaultPrice;
      const measurement = nativeMeasurement();
      const hasMeasurement = Boolean(measurement.root && measurement.input && (measurement.minus || measurement.plus));
      if (price && livePrice) price.textContent = livePrice;
      submit.disabled = disabled;
      submitLabel.textContent = disabled ? label : 'Add to basket';
      submit.setAttribute('aria-label', disabled ? `${label}: ${cleanText(bar.querySelector('.tf-mobile-sticky-purchase__title')?.textContent)}` : `Add ${cleanText(bar.querySelector('.tf-mobile-sticky-purchase__title')?.textContent)} to basket`);
      bar.classList.toggle('tf-mobile-sticky-purchase--with-measure', hasMeasurement);
      document.body.classList.toggle('tf-mobile-sticky-purchase-has-measure', hasMeasurement);
      if (measure) measure.hidden = !hasMeasurement;
      if (!hasMeasurement) return;
      const liveLength = measuraLength() || cleanText(measurement.input.value);
      if (length && liveLength) {
        length.textContent = liveLength;
        length.setAttribute('aria-label', `Selected fabric length: ${liveLength}`);
      }
      if (measureMinus) measureMinus.disabled = isDisabled(measurement.minus);
      if (measurePlus) measurePlus.disabled = isDisabled(measurement.plus);
    }
    function delegateMeasurement(direction) {
      const measurement = nativeMeasurement();
      const nativeControl = direction === 'plus' ? measurement.plus : measurement.minus;
      update();
      if (isDisabled(nativeControl)) {
        focusCanonicalControl();
        return;
      }
      status.textContent = `Updating fabric length ${direction === 'plus' ? 'up' : 'down'} using the selected Measura controls.`;
      nativeControl.click();
      window.setTimeout(update, 0);
      window.setTimeout(update, 160);
    }

    const formObserver = new MutationObserver(update);
    formObserver.observe(productInfo, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'value'] });
    document.addEventListener('variant:change', update);
    document.addEventListener('focusin', (event) => {
      if (productInfo.contains(event.target)) setVisibility(false);
    });
    document.addEventListener('focusout', (event) => {
      if (productInfo.contains(event.target)) window.setTimeout(() => setVisibility(!canonicalInView), 0);
    });
    document.addEventListener('modalClosed', () => window.setTimeout(() => setVisibility(!canonicalInView), 0));
    window.addEventListener('resize', () => setVisibility(!canonicalInView), { passive: true });

    let canonicalInView = true;
    const observer = new IntersectionObserver((entries) => {
      canonicalInView = entries[0]?.isIntersecting ?? true;
      setVisibility(!canonicalInView);
    }, { threshold: 0.1 });
    observer.observe(nativeSubmit);

    summary.addEventListener('click', focusCanonicalControl);
    measureMinus?.addEventListener('click', () => delegateMeasurement('minus'));
    measurePlus?.addEventListener('click', () => delegateMeasurement('plus'));
    submit.addEventListener('click', () => {
      update();
      if (isDisabled(nativeSubmit)) {
        focusCanonicalControl();
        return;
      }
      status.textContent = 'Adding to basket using the selected product options.';
      setVisibility(false);
      nativeSubmit.click();
    });
    update();
  }

  function boot() { document.querySelectorAll(selector).forEach(initialise); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
